import Login from "../views/login/Login.vue";

export default [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      title: "Iniciar sesión",
      requiresAuthentication: false,
      doNotRedirect: true,
    },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "web");

      next();
    },
  },
];
